/** Heights of the phone shell's fixed bars — shared by the shell and by any
 *  phone page that pins something beneath the top bar or scrolls to an anchor. */
export const PHONE_TOP_BAR_HEIGHT = 56;
export const PHONE_TAB_BAR_HEIGHT = 56;
